import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
  selector: 'app-hidden-type',
  template: '',
})
export class HiddenTypeComponent extends FieldType {}
